export enum BREAKPOINTS {
  XS = 379,
  SM = 639,
  MD = 767,
  LG = 1023,
}
